import "./ReportHeaderDetail.scss";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Link, Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { setViewSuccessProfile } from "../../../store/slices/jobPricingDetailsSlice";
import { ReportSuccessProfile } from "../ReportSuccessProfile/ReportSuccessProfile";
import { RootState } from "../../../store/reducers";
import { JobPricingReportViewBy } from "../../../helpers/models/JobPricingDetailModels";
import { ExportReport } from "../ExportReport/ExportReport";
import { useTranslation } from "react-i18next";

export const ReportHeaderDetail = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { reportViewBy, headerDetails } = useSelector(
    (state: RootState) => state.jobPricingDetails
  );

  const openViewSuccessProfile = () => {
    dispatch(setViewSuccessProfile(true));
  };
  return (
    <div className="sjpr-header-details">
      <div className="sjpr-header-details-container">
        <div className="header-details">
          <div className="title-decription-text">
            <Typography variant="h6" sx={{ marginRight: 1 }}>
              {headerDetails.title}
            </Typography>
            {reportViewBy === JobPricingReportViewBy.JOB &&
              headerDetails.description && (
                <Tooltip
                  PopperProps={{
                    disablePortal: true
                  }}
                  title={
                    <>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, marginBottom: 1 }}
                      >
                        {t("pa.description")}:
                      </Typography>
                      <Typography variant="caption">
                        {headerDetails.description}
                      </Typography>
                    </>
                  }
                  arrow
                >
                  <InfoIcon sx={{ color: "#0062CC" }} />
                </Tooltip>
              )}
          </div>
          <div className="header-sub-details">
            {reportViewBy === JobPricingReportViewBy.JOB && (
              <>
                <Typography variant="body2">
                  {t("pa.headerJobcode")} <b>{headerDetails.jobCode}</b>
                </Typography>
                <Divider orientation="vertical" variant="middle" flexItem />
                <Typography variant="body2">
                  {String(headerDetails.grade ?? "").includes(",") ||
                    String(headerDetails.grade ?? "").includes(" - ")
                    ? t("pa.gradespan")
                    : t("pa.grade")}{" "}
                  <b>{headerDetails.grade}</b>
                </Typography>
                <Divider orientation="vertical" variant="middle" flexItem />
                <Typography variant="body2">
                  {headerDetails.function}
                </Typography>
                <Divider orientation="vertical" variant="middle" flexItem />
                <Typography variant="body2">
                  {headerDetails.subFunction}
                </Typography>
              </>
            )}
            {reportViewBy === JobPricingReportViewBy.FUNCTION && (
              <>
                <Typography variant="body2">
                  {t("pa.headerTotalJobs")} <b>{headerDetails.totalJobs}</b>
                </Typography>
                <Divider orientation="vertical" variant="middle" flexItem />
                <Typography variant="body2">
                  {t("pa.gradeSpan")} <b>{headerDetails.gradeSpan}</b>
                </Typography>
              </>
            )}
            {reportViewBy === JobPricingReportViewBy.GRADE && (
              <>
                <Typography variant="body2">
                  {t("pa.headerTotalJobs")} <b>{headerDetails.totalJobs}</b>
                </Typography>
                <Divider orientation="vertical" variant="middle" flexItem />
                <Typography variant="body2">
                  {t("pa.headerJobsInOrg")} <b>{headerDetails.orgJobs}</b>
                </Typography>
              </>
            )}
            {reportViewBy === JobPricingReportViewBy.JOB && (
              <>
                <Divider orientation="vertical" variant="middle" flexItem />
                <Link
                  component="button"
                  variant="body2"
                  title="View success profile"
                  onClick={openViewSuccessProfile}
                >
                  {t("pa.viewSuccessProfile")}
                </Link>
                <ReportSuccessProfile />
              </>
            )}
          </div>
        </div>
        <ExportReport />
      </div>
      <Divider flexItem sx={{ marginY: 2 }} />
    </div>
  );
};
